import React from "react";
import cx from "classnames";
import { t } from "i18next";

const DeliveryDomainStatusBadge = ({ domain, className }) => {
  let style;
  let text;

  const baseStyle = "font-semibold rounded-sm py-[2px] px-1 text-center text-xs";

  const i18n_key = "delivery.domains.status";

  const dns_verified = domain.dns_verification_status === "verified";
  const is_approved = domain.approval_status === "approved";

  if (!domain.status && domain.status_detail === "customer") {
    style = "bg-[--yellow] text-white";
    text = i18n_key + ".disabled_by_customer";
  } else if (!domain.status && domain.status_detail === "admin") {
    style = "bg-[--red] text-white";
    text = i18n_key + ".disabledBydisabled_by_adminAdmin";
  } else if (!domain.status && !dns_verified && !is_approved) {
    style = "bg-[--yellow] text-white";
    text = i18n_key + ".not_verified";
  } else if (!domain.status && dns_verified && !is_approved && domain.approval_status !== "pending") {
    style = "bg-[--yellow] text-white";
    text = i18n_key + ".need_approval";
  } else if (!domain.status && dns_verified && domain.approval_status === "pending") {
    style = "bg-[--blue] text-white";
    text = i18n_key + ".pending_approval";
  } else if (domain.status && !dns_verified) {
    style = "bg-[--green] text-white";
    text = i18n_key + ".approved_dns";
  } else if (domain.status && dns_verified) {
    style = "bg-[--green] text-white";
    text = i18n_key + ".approved";
  }

  return <div className={cx(baseStyle, style, className)}>{t(text)}</div>;
};

export default DeliveryDomainStatusBadge;
